import _ from "lodash";
import { ACTIONS } from "UTILS/Constants";

/**
 * 初期状態値
 */
const initialState = {
  showInboundCoBrowse: false,
  endInboundCoBrowse: true,
  isInboundCobrowseMinimize: false,
};

/**
 * リデューサー本体
 * @param {*} state 現状態値
 * @param {*} action アクション(操作定数と入力値)
 * @returns 操作定数を見て何を行うか分岐し、現状態値と入力値を組み合わせて新状態値を返す
 */
export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.INBOUND_CO_BROWSE.SHOW_INBOUND_CO_BROWSE:
      return{...state, showInboundCoBrowse: action.value}

    case ACTIONS.INBOUND_CO_BROWSE.END_INBOUND_CO_BROWSE_SESSION:
      return{...state, endInboundCoBrowse: action.value}

    case ACTIONS.INBOUND_CO_BROWSE.IS_INBOUND_CO_BROWSE_MINIMIZE:
      return{...state, isInboundCobrowseMinimize: action.value}

    default:
      return state;
  }
}
